import React from "react";
import { earlierWork, selectedProjects } from "../content";
import ExternalLink from "./ExternalLink";
import { useReveal } from "./useReveal";

function ProjectsSection() {
  const selected = useReveal();
  const earlier = useReveal();

  return (
    <>
      <section id="projects" className={`section ${selected.className}`} ref={selected.ref}>
        <div className="shell">
          <p className="eyebrow">Selected</p>
          <h2>Projects</h2>
          <div className="project-list">
            {selectedProjects.map((project, index) => (
              <article
                className={`project-row${index % 2 === 1 ? " is-reversed" : ""}`}
                key={project.title}
              >
                <figure className="project-media">
                  <img
                    src={project.image}
                    alt={project.alt}
                    width={project.width}
                    height={project.height}
                  />
                </figure>
                <div className="project-copy">
                  <h3>{project.title}</h3>
                  <p className="meta">{project.meta}</p>
                  {project.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  <ul className="link-row">
                    {project.links.map((link) => (
                      <li key={link.href}>
                        <ExternalLink href={link.href}>{link.label}</ExternalLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className={`section earlier ${earlier.className}`} ref={earlier.ref} aria-labelledby="earlier-heading">
        <div className="shell">
          <h2 id="earlier-heading">Earlier work</h2>
          <ul className="earlier-list">
            {earlierWork.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <ExternalLink href={item.href}>{item.label}</ExternalLink>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}

export default ProjectsSection;
